import React from 'react'
import { useLocation } from 'react-router'
import Tooltip from '@material-ui/core/Tooltip'
import { PackSearchType } from '../../types/pack'
import { FilterOptions } from '../../types/search'
import { getParams, dateCaptions } from '../../services/search'
import * as date from '../../services/date'
import { FlexContainer } from '../../layouts'
import { H3 } from '../StyledText'
import { FileTreeCheck } from '../GraphicSidebar/FileTreeCheck'
import {
  StyledSearchItemWrapper,
  StyledSearchItemPreview,
  StyledSearchItemFooter,
  StyledSearchItemCaption,
} from './styled'

export const PackListItem = ({
  id: packId,
  title,
  group: groupId,
  thumbnail,
  slugline,
  byline,
  modifiedBy,
  publishing,
  ...rest
}: PackSearchType) => {
  const { date: dateOption = FilterOptions.modified } = getParams(
    useLocation().search
  )
  const dateToShow: string = rest[dateOption] as string
  return (
    <StyledSearchItemWrapper
      to={`/group/${groupId}/pack/${packId}?edition=overall-pack&tab=upload`}
      className="pack-list-item"
    >
      <StyledSearchItemPreview thumbnail={thumbnail as string | undefined} />
      <StyledSearchItemFooter>
        <Tooltip title={`Title: ${title || 'Undefined'}`}>
          <H3>{title || 'Untitled'}</H3>
        </Tooltip>
        <Tooltip title={`Slug: ${slugline}`}>
          <StyledSearchItemCaption className="show-eclipsis">
            {slugline}
          </StyledSearchItemCaption>
        </Tooltip>
        <FlexContainer>
          <Tooltip title={`Byline: ${byline}`}>
            <StyledSearchItemCaption className="show-eclipsis">
              {byline}
            </StyledSearchItemCaption>
          </Tooltip>
          <StyledSearchItemCaption className="delimiter">
            |
          </StyledSearchItemCaption>
          <Tooltip
            title={`${dateCaptions[dateOption]}: ${date.format(dateToShow)}`}
          >
            <StyledSearchItemCaption className="show-eclipsis">
              {date.formatWithToday(dateToShow)}
            </StyledSearchItemCaption>
          </Tooltip>
        </FlexContainer>
        {publishing && (
          <div className="publishing-indicator">
            <FileTreeCheck status="publishing" />
          </div>
        )}
      </StyledSearchItemFooter>
    </StyledSearchItemWrapper>
  )
}
